import { Component, Input } from '@angular/core';
import { PurchaseOrderCommentService } from '../../../services';

@Component({
  selector: 'app-purchase-order-comment',
  templateUrl: './purchase-order-comment.component.html',
  styleUrl: './purchase-order-comment.component.scss',
})
export class PurchaseOrderCommentComponent {
  @Input() isModal = false;
  @Input() showSave = false;
  @Input() showBack = false;
  @Input() id = '';
  @Input() commentStart = '';

  constructor(public purchaseOrderCommentService: PurchaseOrderCommentService) {}
}
